import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

@Injectable()
export class CollaboratorsService {
  public get(): Observable<Array<any>> {
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'collaborators')
      .pipe(map(response => response || []));
  }

  public setCoordinador(idP, idContacte, quin): Observable<Array<any>> {
    return this.authHttp.post<any>(APIURLConstantsService._API_BASE_URL + quin + '/'+idP+'/coordinador/'+idContacte,{})
      .pipe(map(response => response || []));
  }

  public setCoordinadorTecnic(idP, idContacte, quin): Observable<Array<any>> {
    return this.authHttp.post<any>(APIURLConstantsService._API_BASE_URL + quin + '/'+idP+'/coordinadortec/'+idContacte,{})
      .pipe(map(response => response || []));
  }

  constructor(private authHttp: HttpClient) { }

}
